import React from 'react';
import { IntlProvider as IntlNextProvider, useIntl } from 'react-intl-next';
import { useFetchMessagesByLocale } from './useFetchMessagesByLocale';
const IntlProvider = ({
  children
}) => {
  const {
    locale
  } = useIntl();
  const {
    messages
  } = useFetchMessagesByLocale(locale);
  return /*#__PURE__*/React.createElement(IntlNextProvider, {
    messages: messages,
    key: locale,
    locale: locale
  }, children);
};
export default IntlProvider;